<script>
import { mapActions, mapGetters } from 'vuex';
import TableView from '@/components/elements/views/TableView';

export default {
    page: {
        title: 'Users'
    },

    extends: TableView,

    data() {
        return {
            pageTitle: 'Users',
            activeTab: {
                value: null
            },
            downloadingFile: false
        };
    },

    computed: {
        ...mapGetters({
            ALL_ROLES: 'roles/ALL_ROLES'
        }),

        tabsElements() {
            return [{ value: null, text: 'All' }, ...this.ALL_ROLES];
        },

        labels() {
            return [
                { value: 'firstName', width: '200px' },
                {
                    value: 'lastName',
                    width: '200px'
                },
                { value: 'email', width: '300px' },
                { value: 'nickname', width: '200px' },
                {
                    text: 'Role',
                    value: 'roles[0].name',
                    sortable: false,
                    filter: 'startCase',
                    width: '200px',
                    filterable: false
                },
                {
                    value: 'createdAt',
                    filter: 'formatDate',
                    width: '200px',
                    type: 'date'
                },
                {
                    value: 'updatedAt',
                    filter: 'formatDate',
                    width: '200px',
                    type: 'date'
                },
                {
                    text: 'Verified?',
                    value: 'isVerified',
                    type: 'boolean',
                    isBadge: true
                },
                {
                    text: 'Mailing',
                    value: 'postNotificationsEnabled',
                    type: 'boolean',
                    isBadge: true
                }
            ];
        },

        options() {
            const options = {};

            if (this.activeTab.value) {
                options.linkSuffix = `&role=${this.activeTab.value}`;
            }

            return options;
        },

        additionalFetchData() {
            return {
                role: this.activeTab.value
            };
        }
    },

    watch: {
        activeTab() {
            this.pagination.currentPage = 1;
            this.pagination.sortBy = ['createdAt:DESC'];
            this.fetchItems();
        },

        labels() {
            this.tableKey++;
        }
    },

    created() {
        this.fetchItems();
    },

    methods: {
        ...mapActions({
            getItems: 'users/index',
            deleteItem: 'users/destroy'
        }),

        onAddButtonClick() {
            const query = {};

            if (this.activeTab.value !== 'all') {
                query.selectedRole = this.activeTab.value;
            }

            this.$router.push({ path: '/users/add', query });
        },

        onRowClick({ id }) {
            this.$router.push(`/users/${id}/edit`);
        }
    }
};
</script>
